import React from 'react';
import { Routes, Route, Link, useLocation } from 'react-router-dom';
import { AuthContext } from '../../App';
import Overview from './Overview';
import AdminBookAppointment from './AdminBookAppointment';
import Appointments from './Appointments';
import Clients from './Clients';
import Services from './Services';
import Stylists from './Stylists';
import Portfolio from './Portfolio';
import Payments from './Payments';
import ServiceHistory from './ServiceHistory';
import Reports from './Reports';
import Inventory from './Inventory';

function Dashboard() {
  const { logout } = React.useContext(AuthContext);
  const location = useLocation();
  const navRef = React.useRef(null);

  React.useEffect(() => {
    // Force remove hover state when route changes
    if (navRef.current) {
      const navGroups = navRef.current.querySelectorAll('.nav-group');
      navGroups.forEach(group => {
        // Temporarily remove pointer events to break the hover state
        group.style.pointerEvents = 'none';
        setTimeout(() => {
          group.style.pointerEvents = '';
        }, 10);
      });
    }
  }, [location.pathname]);

  return (
    <div className="dashboard">
      <nav className="dashboard-nav" ref={navRef}>
        <h1>Salon Manager</h1>
        <div className="nav-links">
          <Link to="/dashboard">Overview</Link>

          <div className="nav-group">
            <span className="nav-group-label">Bookings</span>
            <div className="nav-dropdown">
              <Link to="/dashboard/book">Book Appointment</Link>
              <Link to="/dashboard/appointments">Appointments</Link>
            </div>
          </div>

          <div className="nav-group">
            <span className="nav-group-label">Management</span>
            <div className="nav-dropdown">
              <Link to="/dashboard/clients">Clients</Link>
              <Link to="/dashboard/services">Services</Link>
              <Link to="/dashboard/stylists">Stylists</Link>
              <Link to="/dashboard/inventory">Inventory</Link>
            </div>
          </div>

          <div className="nav-group">
            <span className="nav-group-label">Financial</span>
            <div className="nav-dropdown">
              <Link to="/dashboard/payments">Payments</Link>
              <Link to="/dashboard/history">Service History</Link>
              <Link to="/dashboard/reports">Reports</Link>
            </div>
          </div>

          <Link to="/dashboard/portfolio">Portfolio</Link>
          <button onClick={logout} className="logout-btn">Logout</button>
        </div>
      </nav>
      <div className="dashboard-content">
        <Routes>
          <Route path="/" element={<Overview />} />
          <Route path="/book" element={<AdminBookAppointment />} />
          <Route path="/appointments" element={<Appointments />} />
          <Route path="/clients" element={<Clients />} />
          <Route path="/services" element={<Services />} />
          <Route path="/stylists" element={<Stylists />} />
          <Route path="/portfolio" element={<Portfolio />} />
          <Route path="/payments" element={<Payments />} />
          <Route path="/history" element={<ServiceHistory />} />
          <Route path="/reports" element={<Reports />} />
          <Route path="/inventory" element={<Inventory />} />
        </Routes>
      </div>
    </div>
  );
}

export default Dashboard;
